import { useEffect, useState } from 'react';
import { getLogger } from '@sas/nova-core/logging';
import { GenericKnownObject } from '@sas/react-svg';
const logger = getLogger('react-svg');
const resolveSVGPlaceholder = (_n, _t) => GenericKnownObject;
const resolveIconPlaceholder = (_n, _t) => GenericKnownObject;

/**
 * Dynamically imports and returns `resolveIcon` and `resolveSVG` for more convenient
 * tree shaking.
 */
export const useResolveSVGIcon = () => {
  const [lib, setLib] = useState({
    resolveSVG: resolveSVGPlaceholder,
    resolveIcon: resolveIconPlaceholder
  });
  useEffect(() => {
    let ignoreImport = false;
    import( /* webpackMode: "lazy" */
    '@sas/react-svg/dynamic').then(i => {
      if (ignoreImport) return;
      setLib({
        resolveSVG: i.resolveSVG,
        resolveIcon: i.resolveIcon
      });
    }).catch(err => logger.error(err));
    return () => {
      ignoreImport = true;
    };
  }, []);
  return lib;
};
//# sourceMappingURL=useResolveSVGIcon.js.map